import { Injectable, NgModule } from "@angular/core";
import { BfxBlotterActionSubject } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";

@Injectable({ providedIn: "root" })
export class BmarkSummaryActionSubject extends BfxBlotterActionSubject {
  //
}

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [BmarkSummaryActionSubject],
  bootstrap: [],
})
export class BmarkSummaryActionSubjectModule {}
